export default {
    "title": "Fichas técnicas / {{client}}",
    "filters": {
        "materialType": "Tipo de material",
        "material": "Material",
        "description": "Descripción",
        "technicalSheetNumber": "Código AC",
        "diameter": "Diámetro (cm)",
        "height": "Altura (mm)",
        "zbot": "Botes",
        "ztap": "Tapas",
        "zaux": "Tapones",
        "all": "Todos"
    },
    "technicalsSheetsHeader": "<0>{{count}}</0> fichas técnicas encontradas",
    "technicalsSheetsZBotHeader": "<0>{{count}}</0> botes encontrados",
    "technicalsSheetsZTapHeader": "<0>{{count}}</0> tapas encontradas",
    "technicalsSheetsZAuxHeader": "<0>{{count}}</0> tapones encontrados",
    "technicalsSheetsTableColumns": {
        "material": "Material",
        "description": "Descripción",
        "codeAC": "Código AC",
        "packingStandard": "Norma embalaje",
        "diameter": "Diámetro (cm)",
        "height": "Altura (mm)",
        "download": "Descargar (PDF)"
    },
    "nameCollection": "fichas técnicas"
}